import { render, staticRenderFns } from "./TwoStepAuth.vue?vue&type=template&id=0d40bacc&scoped=true&"
import script from "./TwoStepAuth.vue?vue&type=script&lang=js&"
export * from "./TwoStepAuth.vue?vue&type=script&lang=js&"
import style0 from "./TwoStepAuth.vue?vue&type=style&index=0&id=0d40bacc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d40bacc",
  null
  
)

export default component.exports